const BASE_URL = import.meta.env.VITE_APP_API_URL;
import { deleteCredentials } from '@shared/utils/delete-credentials';
import { getCredentials } from '@shared/utils/get-credentials';
import { useAuthStore } from '../store/auth-store';
import { PUBLIC_PATH } from '../router/paths';

export const fetchRefreshToken = async () => {
  const { refreshToken } = getCredentials();

  if (!refreshToken) {
    return null;
  }

  try {
    const response = await fetch(`${BASE_URL}auth/tokens/refresh/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh: refreshToken }),
    });

    if (!response.ok) throw new Error('Failed to refresh token');

    const { access } = await response.json();
    useAuthStore.getState().setAccessToken(access);

    return access;
  } catch (err) {
    console.error('Failed to refresh token', err);
    window.location.href = PUBLIC_PATH.LOGIN;
    deleteCredentials();
    return null;
  }
};
